// extracted by mini-css-extract-plugin
export var circle = "_a5-1";
export var exitConfirmationModal = "_a5-5";
export var iframe = "_a5-0";
export var offline = "_a5-3";
export var online = "_a5-2";
export var workstationSelectError = "_a5-4";